import { action } from 'satcheljs';
export const initializeMailLayout = action('initializeMailLayout');
